var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfound"},[_c('img',{attrs:{"src":require("@/assets/images/403.png")}}),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.user.name ? '当前账号不属于内部账号(酷开域账号或tenant)' : '暂无权限'))]),(!_vm.user.name)?_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.loginSSO}},[_vm._v("去登录吧")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }